import * as React from 'react';
import axios from 'axios';
import * as Cookies from 'js-cookie';
import { Switch, Route } from 'react-router-dom';
import AuthContext from './AuthContext';
import Login from './Login';
import SignUp from './SignUp';
import ForgotPassword from './ForgotPassword';
import Loader from './Loader';
import {
    SIGNUP,
    LOGIN,
    FORGOT_PASSWORD,
    RESET_PASSWORD
} from '../constants/routes';
import ResetPassword from './ResetPassword';
import PageNotFound from './PageNotFound';
import { getFeaturedRapidSolution } from '../utils/authProcess';

const AuthRouter = () => {
    const [signedIn, setSignedIn] = React.useState(null);
    const rapidSolution = getFeaturedRapidSolution();

    React.useEffect(() => {
        const authenticate = async () => {
            const cssToken = Cookies.get('csst');
            if (cssToken) {
                try {
                    const statusRequestConfig = {
                        headers: { Authorization: `Bearer ${cssToken}` },
                        withCredentials: true
                    };

                    const statusResponse = await axios.post(
                        `${process.env.INCA_SERVER_URL}/auth/status`,
                        {},
                        statusRequestConfig
                    );

                    if (statusResponse.status === 403) {
                        throw 'failed to check auth status';
                    } else if (statusResponse.status === 200) {
                        const authToken = statusResponse.data.token;

                        if (authToken) {
                            window.location.href =
                                process.env.PORTAL_URL + '/' + rapidSolution;
                        } else {
                            setSignedIn(false);
                        }
                    }
                } catch (err) {
                    setSignedIn(false);
                }
            } else {
                setSignedIn(false);
            }
        };
        authenticate();
    }, []);

    if (signedIn === false) {
        return (
            <Switch>
                <Route exact path={['/', LOGIN]} component={Login} />
                <Route path={SIGNUP} component={SignUp} />
                <Route path={FORGOT_PASSWORD} component={ForgotPassword} />
                <Route path={RESET_PASSWORD} component={ResetPassword} />
                <Route component={PageNotFound} />
            </Switch>
        );
    } else {
        return <Loader isFixed={true} />;
    }
};

export default AuthRouter;
